import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import SVG from '../svg';
import IdleTimer from 'react-idle-timer';

import Header from '../../containers/header';
import Footer from '../footer';
import Navigation from '../../containers/navigation';
import UserInfo from '../../containers/userInfo';
import EventInfo from '../../containers/eventInfo';
import Dashboard from '../../containers/dashboard';
import Calendar from '../../containers/calendar';
import Homepage from '../../containers/homepage';
import Reporting from '../../containers/reporting';
import Alerts from '../../containers/alerts';
import Styleguide from '../styleguide';
import Search from '../../containers/search';
import Details from '../details';
import ErrorPage from '../errorPage';
import Event from '../../containers/event';
import Loading from '../ui/loading-spinner';
import Login from '../../containers/login';
import ModalSession from '../ui/modal-session';
import Admin from '../../containers/admin';

class App extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = null;
        this.timer = null;
        this.logoutTimer = 30;
        this.state = {
            timeLeft: this.logoutTimer
        };
    }

    onIdle = () => {
        this.props.setSessionModal();
        clearInterval(this.timer);
        this.timer = setInterval(this.countdown, 1000);
    };

    countdown = () => {
        if (this.state.timeLeft > 0) {
            this.setState({ timeLeft: --this.state.timeLeft });
        } else {
            clearInterval(this.timer);
            this.props.unAuthUser();
        }
    };

    actionOk = () => {
        clearInterval(this.timer);
        this.setState({ timeLeft: this.logoutTimer });
        this.props.verifySessionUser();
        this.props.setSessionModal();
        this.idleTimer.reset();
    };

    componentDidMount() {
        this.props.history.listen(() => {
            this.props.closeNav();
            this.props.closeSearch();
        });
    }

    render() {
        if (
            process.env.NODE_ENV === 'development' &&
            !this.props.authentication
        ) {
            return <Route exact path="/login" component={Login} />;
        }

        return this.props.userLoading ? (
            <Loading />
        ) : (
            <div>
                <SVG />
                <IdleTimer
                    ref={ref => {
                        this.idleTimer = ref;
                    }}
                    onIdle={this.onIdle}
                    stopOnIdle={true}
                    timeout={30 * 60 * 1000}
                    // timeout={5000}
                />
                {this.props.getSessionModal && (
                    <ModalSession
                        isActive={this.props.getSessionModal}
                        seconds={this.state.timeLeft}
                        actionOk={this.actionOk}
                    />
                )}
                <main className="wrapper">
                    <Header />
                    <div className="userName">
                        <span>Welcome</span> {this.props.userName}
                    </div>
                    <section id="main-content" className="wrapper__content">
                        <Switch>
                            <Route exact path="/" component={Homepage} />
                            <Route path="/user-info" component={UserInfo} />
                            <Route
                                path="/eventInfo/:id"
                                component={EventInfo}
                            />
                            <Route path="/event" component={Event} />
                            <Route path="/admin" component={Admin} />

                            <Route path="/alerts" component={Alerts} />
                            <Route path="/dashboard" component={Dashboard} />
                            <Route path="/calendar" component={Calendar} />
                            <Route path="/reporting" component={Reporting} />
                            <Route path="/styleguide" component={Styleguide} />
                            <Route path="/details" component={Details} />
                            <Route component={ErrorPage} />
                        </Switch>
                    </section>
                    <Footer />
                </main>

                <Navigation location={this.props.location} />
                <Search />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/app/index.js